// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"kr"};